/* eslint-disable import/prefer-default-export */
import React from 'react';

export const CountryContext = React.createContext({
  country: 'au',
});
